import { render, staticRenderFns } from "./home-tabs.vue?vue&type=template&id=7b79ae02&scoped=true&"
import script from "./home-tabs.vue?vue&type=script&lang=js&"
export * from "./home-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b79ae02",
  null
  
)

export default component.exports